/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import DLTAutocomplete from '@shared/components/form/DLTAutocomplete';
import DLTTextField from '@shared/components/form/DLTTextField';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import DateFnsAdapter from '@date-io/date-fns';
import { LoadingButton } from '@mui/lab';
const countries = require('i18n-iso-countries');
const enLocale = require('i18n-iso-countries/langs/en.json');
countries.registerLocale(enLocale);
const countryList = Object.entries(countries.getNames('en', { select: 'official' })).map(([code, name]) => ({
    value: code,
    label: name,
}));
const dateFns = new DateFnsAdapter();
const formSchema = yup.object({
    natural_person_first_name: yup.string().required().default(''),
    natural_person_last_name: yup.string().required().default(''),
    natural_person_country_of_birth: yup.string().required().default(''),
    natural_person_date_of_birth: yup.date().required().default(dateFns.date()),
});
const NaturalPersonForm = (props) => {
    const { control, trigger, formState, handleSubmit } = useForm({
        defaultValues: formSchema.getDefault(),
        resolver: yupResolver(formSchema),
    });
    const onSubmit = () => {
        handleSubmit((data) => props.onNext(Object.assign(Object.assign({}, data), { natural_person_date_of_birth: data.natural_person_date_of_birth.toISOString() })))();
    };
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Typography, { variant: 'subtitle2' }, "Natural Person Information"),
        React.createElement(Typography, { variant: 'caption' }, "Please provide infromation about the individual who sent this deposit:"),
        React.createElement(Box, { component: 'form' },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
                React.createElement(DLTTextField, { control: control, name: 'natural_person_first_name', label: 'First name' }),
                React.createElement(DLTTextField, { control: control, name: 'natural_person_last_name', label: 'Last name' }),
                React.createElement(DLTAutocomplete, { control: control, name: 'natural_person_country_of_birth', options: countryList, label: 'County of Birth' }),
                React.createElement(Controller, { control: control, name: 'natural_person_date_of_birth', rules: { required: true }, render: ({ field }) => {
                        return (React.createElement(DatePicker, { label: 'Date of birth', format: 'dd/MM/yyyy', views: ['year', 'month', 'day'], openTo: 'year', disableFuture: true, slotProps: { textField: { size: 'small' } }, value: field.value, inputRef: field.ref, onChange: (date) => {
                                field.onChange(date);
                                trigger('natural_person_date_of_birth');
                            } }));
                    } }))),
        React.createElement(LoadingButton, { loading: props.loading, variant: 'contained', disabled: !formState.isValid, onClick: onSubmit }, "Submit"),
        React.createElement(Button, { variant: 'outlined', onClick: () => {
                props.onBack();
            } }, "Back")));
};
export default NaturalPersonForm;
